import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import { handleAddressChange } from 'checkout/checkout/common/helpers';
import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError } from 'common/components/layout';
import { isPreSale } from 'common/helpers/featureFlags';
import {
  getDefaultCountryCode,
  getOperatingCountryCodes,
  getClubList
} from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { phoneFormat } from 'common/helpers/phoneHelper';
import { updateClubSignup } from 'redux/clubSignup/actions';
import { listCustomerAddresses } from 'redux/customerAddresses/actions';

import AddressPicker from './components/AddressPicker';
import CustomerDisplay from './components/CustomerDisplay';
import GiftMessage from './components/GiftMessage';
import ShippingInstructions from './components/ShippingInstructions';
import { validateForLoggedInCustomerShip } from './validators';

class Customer extends Component {
  componentDidMount() {
    const { props } = this;
    props.listCustomerAddresses();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const clubSignup = {
      shipTo: data,
      orderDeliveryMethod: 'Ship',
      giftMessage: data.giftMessage,
      shippingInstructions: data.shippingInstructions
    };
    delete clubSignup.shipTo.giftMessage;
    delete clubSignup.shipTo.shippingInstructions;
    props.updateClubSignup(clubSignup);
  };

  handlePickup = (e) => {
    e.preventDefault();
    const { onPickup } = this.props;
    onPickup();
  };

  handleAddressChange = (e) => {
    const { props } = this;
    const addressId = e.target.value;
    let address;
    if (addressId) {
      address = props.customerAddresses.data[addressId];
    }
    handleAddressChange(addressId, address, props.change, props.settings);
  };

  render() {
    const { clubSignup, customer, change, handleSubmit, settings } = this.props;
    const { customerAddresses, form } = this.props;
    let object = clubSignup.shipTo;
    if (!object) {
      object = { countryCode: getDefaultCountryCode(settings) };
    }
    if (getOperatingCountryCodes(settings).length === 1) {
      object.countryCode = getDefaultCountryCode(settings);
    }
    let clubSelection = 'club selection';
    if (isPreSale()) {
      clubSelection = 'pre-sale selection';
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <CustomerDisplay customer={customer.data} />
        <p>&nbsp;</p>
        <div className="c7-checkout__content__title">
          <h3>Shipping address</h3>
          <a
            className="c7-checkout__content__title__pickup"
            onClick={this.handlePickup}
          >
            I prefer to pick up my club shipment
          </a>
        </div>
        <AddressPicker
          customerAddresses={customerAddresses.data}
          onAddressChange={this.handleAddressChange}
        />
        <AddressForm
          object={object}
          changeFunction={change}
          type="Operating"
          settings={settings}
        />
        <GiftMessage clubSignup={clubSignup} />
        <ShippingInstructions clubSignup={clubSignup} />

        <div className="c7-checkout__content__buttons">
          <button className="c7-button" type="submit">
            Continue to billing information
          </button>
          <a href={`${getClubList(settings)}`}>Return to {clubSelection}</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const data = transformAddressData(values);
  data.customerAddressId = values.customerAddressId;
  if (values.isGiftMessage) {
    data.giftMessage = values.giftMessage;
  } else {
    data.giftMessage = null;
  }
  if (values.isShippingInstructions) {
    data.shippingInstructions = values.shippingInstructions;
  } else {
    data.shippingInstructions = null;
  }
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  data.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  data.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  data.birthYear = values.birthYear && convertStringToInteger(values.birthYear);
  const errors = validateForLoggedInCustomerShip(data, ownProps.settings);
  return errors;
};

const mapStateToProps = (state) => {
  let initialValues;
  if (state.clubSignup) {
    const { shipTo } = state.clubSignup.data;
    const { customer } = state;
    if (shipTo) {
      initialValues = initialFormValues(shipTo);
      initialValues.customerAddressId = shipTo.customerAddressId;
    } else {
      initialValues = initialFormValues(customer.data);
      if (customer.data.phones.length) {
        initialValues.phone = phoneFormat(
          customer.data.phones[0].phone,
          customer.data.countryCode
        );
      }
    }
  }
  if (
    !initialValues.countryCode ||
    getOperatingCountryCodes(state.setting).length === 1
  ) {
    initialValues.countryCode = getDefaultCountryCode(state.setting);
  }
  return {
    clubSignup: state.clubSignup,
    customer: state.customer,
    settings: state.setting,
    customerAddresses: state.customerAddress,
    initialValues
  };
};

Customer = reduxForm({
  form: 'customerLoggedInShip',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate,
  asyncBlurFields: ['zipCode']
})(Customer);

export default connect(mapStateToProps, {
  listCustomerAddresses,
  updateClubSignup
})(Customer);
